// extracted by mini-css-extract-plugin
export default {"Container":"CenteredView_Container__juxnu"};